var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAudit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m120 90h120v30h-120z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120 150h135v30h-135z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120 210h120v30h-120z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120 270h120v30h-120z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120 330h120v30h-120z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m510 270c0-61.089-45.886-111.66-105-119.064v-52.149l-98.787-98.787h-246.213v30h-60v480h375v-60h30v-60.935c59.114-7.405 105-57.976 105-119.065zm-195-218.787 38.787 38.787h-38.787zm30 428.787h-315v-420h30v390h285zm-255-60v-390h195v90h90v30.936c-59.114 7.404-105 57.975-105 119.064s45.886 111.66 105 119.065v30.935zm300-60c-49.626 0-90-40.374-90-90s40.374-90 90-90 90 40.374 90 90-40.374 90-90 90z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m375 278.787-19.394-19.393-21.212 21.212 40.606 40.607 70.606-70.607-21.212-21.212z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudit);
export default __webpack_public_path__ + "static/media/audit.766f1d41f7f6ba0337ba6d56d751ed2d.svg";
export { ForwardRef as ReactComponent };